<template>
  <div>
    <b>依据单位导出学员详细信息</b>
    <UnitCascader @onValueChanged="onUnitChanged"></UnitCascader>
    <el-button type="primary" @click="exportExl" :loading="loading">导出</el-button>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import { UnitCascader } from "@/views/components/select";
import { exportApi } from "@/api/module/export/export";

export default {
  name: "ExportScheduleDetailByUnitBtn",
  
  mixins: [BaseVue],
  
  components: {
    UnitCascader
  },
  
  data() {
    return {
      sdate: "",
      edate: "",
      unitids: '',
      data: {},
      loading: false
    };
  },
  
  methods: {
    onUnitChanged(val) {
      console.log("onUnitChanged", val);
      this.unitids = val;
    },
    
    init() {
      // 初始化逻辑
    },
    
    setData(date1, date2) {
      this.sdate = date1;
      this.edate = date2;
    },
    
    exportExl() {
      this.loading = true;
      
      let serverUrl = "/api/manager/export/schedule/details/unit";
      
      let data = {
        sdate: this.sdate,
        edate: this.edate,
        unitids: this.unitids
      };
      
      let filename = "党校微课堂详情数据.xls";
      
      console.log("exportExl", serverUrl);
      
      exportApi(data, serverUrl)
        .then((res) => {
          let data = res.data;
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.$message.error("服务器内部错误!");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  
  created() {
    // 组件创建时的逻辑
  }
};
</script>

<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>